//TODO: ESTE ES EL ARCHIVO PINCIPAL PARA LOS DEMAS COMPONENTES.
//TODO: Todos loc componentes deben empezar un mayuscula y exportarlo aki al archivo principal.
import React, {Fragment, useState} from 'react';
import Header from './componentes/Header';
import Formulario from './componentes/Formulario';
import Mensaje from './componentes/Mensaje';
import Resultado from './componentes/Resultado';
import Spinner from './componentes/Spinner';

function App() {

    //TODO: 01 Definimos el state, OJO que AKI estamos llamdon del padre es app.js al hijo es formulario.
    //ESTO ES IMPORTANTE PARA PODER USARLO EN OTRO COMPONENTES
    //del padre al hijo siempre. viseversa no se podra.
    const [cantidad, guardarCantidad] = useState(0);
    const [plazo, guardarPlazo] = useState('');
    const [total, guardarTotal] = useState(0);
    const [cargando, guardarCargando] = useState(false);

    let componente;
    if (cargando) {
      componente = <Spinner />
    } else if (total === 0) {
      componente = <Mensaje />
    }else{
      componente = <Resultado
                  total={total}
                  plazo={plazo}
                  cantidad={cantidad} />
    }


  //LOS COMPONENTES LOS COLOCAMOS COMO <Header>
  //igual como el nombre del archivo
  return (
    <Fragment>
    
      <Header
        titulo="Cotizador de prestamos"
      />

      <div className='container'>
        <Formulario 
          cantidad={cantidad}
          guardarCantidad={guardarCantidad}
          plazo={plazo}
          guardarPlazo={guardarPlazo}
          total={total}
          guardarTotal={guardarTotal}
          guardarCargando={guardarCargando}
        />
        <div className="mensajes">
          {componente}
        </div>
      </div>

    </Fragment>
  );
}

export default App;
